import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './GuildWar.css';

const GuildWar = () => {
  const [guildName, setGuildName] = useState('');
  const [guildGid, setGuildGid] = useState('');
  const [defenders, setDefenders] = useState([]);
  const [guildNames, setGuildNames] = useState([]);
  const [event, setEvent] = useState('guildWar');
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const fetchGuildWarData = async () => {
    setIsLoading(true);
    try {
      setIsError(false);

      const response = await axios.get(
        `https://rangers-api-3mfw.onrender.com/api/guild-info/00e6947f32afa26dc1dfcc19f1a2628e/members`,
        {
          params: {
            eventType: "pvp",
          },
        }
      );

      const data = response.data;
      setDefenders(data);
    } catch (error) {
      setIsError(true);
      console.error('Error fetching data:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchGuildWarData();
  }, []);

  const getSwitchText = (equipMap) => {
    if (!equipMap.attr4No) {
      return '';
    }
    if (typeof equipMap.attr4No !== 'string') {
      equipMap.attr4No = String(equipMap.attr4No);
    }
    const prefix = equipMap.attr4No.substring(0, 2);
    const suffix = equipMap.attr4No.substring(4, 6);

    const switchTexts11 = {
      '01': '物攻',
      '02': '命中',
      '03': 'ス発',
      '04': 'ス命',
      '05': '攻ス',
      '06': '体力',
      '07': '回避',
      '08': 'ス回',
      '09': 'ス抵',
      '10': '物反',
      '11': '魔反',
      '12': 'ﾉｯｸ',
      '13': 'ｽﾀﾝ',
      '14': '沈黙',
      '15': '移動',
      '16': '攻範',
      '17': 'ミネ',
      '18': '再出',
    };

    const switchTexts12 = {
      '01': '物攻',
      '02': '命中',
      '03': '決確',
      '04': '決ダ',
      '05': 'ス発',
      '06': 'ス命',
      '07': '攻ス',
      '08': '体力',
      '09': '回避',
      '10': 'ス回',
      '11': 'ス抵',
      '12': 'ﾉｯｸ',
      '13': 'ｽﾀﾝ',
      '14': '沈黙',
      '15': '移動',
      '16': '攻範',
      '17': 'ミネ',
      '18': '再出',
    };

    const switchTexts13 = {
      '01': '魔攻',
      '02': '命中',
      '03': 'ス発',
      '04': 'ス命',
      '05': '攻ス',
      '06': '物防',
      '07': '魔防',
      '08': '体力',
      '09': '回避',
      '10': 'ス回',
      '11': 'ス抵',
      '12': 'ﾉｯｸ',
      '13': 'ｽﾀﾝ',
      '14': '沈黙',
      '15': '移動',
      '16': '攻範',
      '17': 'ミネ',
      '18': '再出',
    };

    const switchTexts14to18 = {
      '01': '物攻',
      '02': '魔攻',
      '03': '命中',
      '04': 'ス発',
      '05': 'ス命',
      '06': '攻ス',
      '07': '体力',
      '08': '回避',
      '09': 'ス回',
      '10': 'ス抵',
      '11': 'ﾉｯｸ',
      '12': 'ｽﾀﾝ',
      '13': '沈黙',
      '14': '移動',
      '15': '攻範',
      '16': 'ミネ',
      '17': '再出',
      '18': '属強',
      '19': '属命',
    };

    let switchText = '';
    if (prefix === '11') {
      switchText = switchTexts11[suffix];
    } else if (prefix === '12') {
      switchText = switchTexts12[suffix];
    } else if (prefix === '13') {
      switchText = switchTexts13[suffix];
    } else if (
      prefix === '14' ||
      prefix === '15' ||
      prefix === '16' ||
      prefix === '17' ||
      prefix === '18'
    ) {
      switchText = switchTexts14to18[suffix];
    }

    return switchText ? switchText + (equipMap.currentAdvancedEnchant ?? '?') : '不明';
  };

  const selectGroup = (
    <div className="select-group">
      <h1>ドリチー情報</h1>
    </div>
  );

  return (
    <div className="guild-war-container">
      {selectGroup} {/* 選択部分は常に表示 */}

      {isError ? (
        <p>データの取得中にエラーが発生しました。後でもう一度お試しください。</p>
      ) : isLoading ? (
        <p>データ読み込み中...(数分ほどかかる場合があります)</p>
      ) : (
        <>
          <br />

          {defenders.map((defender, index) => {
            const eventInfo = defender.eventInfo || [];
            const playerName = defender.userName || '名前不明';
            const pvpLeaguePhase = defender.pvpLeaguePhase || 'PVP不明';

            return (
              <div key={index} className="defender-card">
                <br />
                <h3>{playerName}</h3>
                <p>{pvpLeaguePhase}</p>
                <table className="deck-table">
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>レンジャー</th>
                      <th>武器</th>
                      <th>防具</th>
                      <th>アクセ</th>
                    </tr>
                  </thead>
                  <tbody>
                    {eventInfo.length === 0 ? (
                      <tr>
                        <td colSpan="5">デッキ情報がありません。</td>
                      </tr>
                    ) : (
                      eventInfo['1']?.map((team, teamIndex) => (
                        <tr key={teamIndex}>
                          <td>{teamIndex + 1}</td>
                          <td>
                            <img 
                              src={`https://rangers.lerico.net/res/${team.unitCode}/${team.unitCode}-thum.png`} 
                              alt={`ユニット ${team.unitCode}`} 
                              className="unit-img"
                            />
                            <div>{team.unitLevel}</div>
                          </td>
                          <td>
                            {team.equipMap?.WEAPON ? (
                              <>
                                <img 
                                  src={`https://rangers.lerico.net/res/gear_icon/${team.equipMap.WEAPON.equipItemCode}_icon.png`} 
                                  alt="武器"
                                  className="gear-img"
                                />
                                <div>{getSwitchText(team.equipMap.WEAPON)}</div>
                              </>
                            ) : 'なし'}
                          </td>
                          <td>
                            {team.equipMap?.ARMOR ? (
                              <>
                                <img 
                                  src={`https://rangers.lerico.net/res/gear_icon/${team.equipMap.ARMOR.equipItemCode}_icon.png`} 
                                  alt="防具"
                                  className="gear-img"
                                />
                                <div>{getSwitchText(team.equipMap.ARMOR)}</div>
                              </>
                            ) : 'なし'}
                          </td>
                          <td>
                            {team.equipMap?.ACC ? (
                              <>
                                <img 
                                  src={`https://rangers.lerico.net/res/gear_icon/${team.equipMap.ACC.equipItemCode}_icon.png`} 
                                  alt="アクセ"
                                  className="gear-img"
                                />
                                <div>{getSwitchText(team.equipMap.ACC)}</div>
                              </>
                            ) : 'なし'}
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
                <br />
              </div>
            );
          })}
        </>
      )}
    </div>
  );
};

export default GuildWar;
